import { createSelector } from 'reselect';
import moment from 'moment';

const myTaskResponses = state => state.taskTraining.myTaskResponses;

const taskResponsesLateAck = createSelector([myTaskResponses], (taskResponses) => {
  return taskResponses.filter(tr => {
    const late = moment(tr.createdAt).add(24, 'hours');
    return !tr.acknowledgedAt && moment().isSameOrAfter(late) && tr.status === 'submitted';
  })
});

const taskResponsesWaitingAck = createSelector([myTaskResponses], (taskResponses) => {
  return taskResponses.filter(tr => {
    const late = moment(tr.createdAt).add(24, 'hours');
    return !tr.acknowledgedAt && moment().isBefore(late) && tr.status === 'submitted';
  })
});


export {
  taskResponsesLateAck,
    taskResponsesWaitingAck
}
